import { render, staticRenderFns } from "./BaseYxRealName.vue?vue&type=template&id=3d11794a&scoped=true"
import script from "./BaseYxRealName.vue?vue&type=script&lang=js"
export * from "./BaseYxRealName.vue?vue&type=script&lang=js"
import style0 from "./BaseYxRealName.vue?vue&type=style&index=0&id=3d11794a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d11794a",
  null
  
)

export default component.exports